import React from 'react';

const WhyPartnerships = () => {
  const reasons = [
    {
      number: '1',
      gradient: 'from-hector-blue to-cyan-400',
      title: 'The Amazon ecosystem is fragmented.',
      description: 'Agencies, freelancers, consultants, and ex-Amazon employees are scattered across the space but they all have direct relationships with sellers and brands. Traditional sales can\'t reach them. You can.'
    },
    {
      number: '2',
      gradient: 'from-hector-purple to-pink-400',
      title: 'You speak their language.',
      description: 'A cold sales call from Hector means nothing. A recommendation from someone inside the ecosystem? That closes deals in days. You already have the credibility. We just need you to introduce us.'
    },
    {
      number: '3',
      gradient: 'from-green-400 to-cyan-400',
      title: 'We need distribution, not inventory.',
      description: 'Unlike other affiliate programs, we\'re not asking you to become a marketer. We\'re not shipping you product demos or asking you to attend training seminars. We just need you to refer people who are already looking for solutions.'
    },
    {
      number: '4',
      gradient: 'from-yellow-400 to-orange-400',
      title: 'This is better than freelance work.',
      description: 'As a freelancer or agency owner, you\'re trading time for money. As an affiliate, you build passive revenue, getting paid month after month just for making one good introduction.'
    }
  ];

  return (
    <section id="why-partnerships" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            We're Building Partnerships <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">That Pay</span>
          </h2>
          <p className="text-xl text-hector-dark-grey">
            Here's why we're doing this:
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {reasons.map((reason, index) => (
            <div key={index} className="numbered-card bg-gradient-to-br from-white to-hector-light-grey rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="flex items-start space-x-4">
                <div className={`flex-shrink-0 w-12 h-12 bg-gradient-to-br ${reason.gradient} rounded-xl flex items-center justify-center text-white font-bold text-xl`}>
                  {reason.number}
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-hector-black mb-3">{reason.title}</h3>
                  <p className="text-gray-600 leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
      <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button 
    className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    JOIN ACTIVE AFFILIATES TODAY
  </button>
</a>

          <p className="text-sm text-gray-600">
            <span className="font-bold text-hector-black">Your network = $50K+ annual seller savings</span>. Start today.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyPartnerships;
